import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'

const resource = `${Config.basePath}/ticket`
const messageResource = `${Config.basePath}/ticket-message`

export default {

  // region Ticket 🎫
  getTickets(params) {
    return Client.get(`${resource}`, {
      params,
    })
  },
  getTicketById(ticketId) {
    return Client.get(`${resource}/${ticketId}`)
  },
  createTicket(payload) {
    return Client.post(`${resource}/create`, {
      ...payload,
    })
  },
  updateTicket(ticketId, payload) {
    return Client.put(`${resource}/update/${ticketId}`, {
      ...payload,
    })
  },
  deletedTicket(ticketId) {
    return Client.delete(`${resource}/delete/${ticketId}`)
  },
  // endregion

  // region History 📖
  getTicketsHistory(customerId) {
    return Client.get(`${resource}?customerId=${customerId}`)
  },
  // region History 📖
  getChatMeTicketsHistory(roomId) {
    return Client.get(`${resource}/chatme/${roomId}`)
  },
  // endregion

  // region Messages 💬
  getTicketMessageById(ticketId, params) {
    return Client.get(`${messageResource}/${ticketId}`, {
      params,
    })
  },
  createTicketMessage(payload) {
    return Client.post(`${messageResource}/create`, {
      ...payload,
    })
  },
  // endregion

  // region Creates Form Option 🍍
  getTicketAssignOption() {
    return Client.get(`${resource}/assign`)
  },
  getTicketPriorityOption() {
    return Client.get(`${resource}/levels`)
  },
  // endregion
}
